import { ColumnLinks, Link, PromoCard } from '../types';

export const subtitle = 'See what products our advisors can help with';

export const bankingLinks: ColumnLinks = {
  title: 'Banking',
  links: [
    { text: 'Thrivent Bank', href: 'https://access.thriventbank.com/' },
    { text: 'Church Loans', href: 'https://www.thriventchurchloans.com/' },
    { text: 'All Banking', href: 'http://www.thrivent.com/banking' },
  ],
};

export const investmentLinks: ColumnLinks = {
  title: 'Investments',
  links: [
    { text: 'Annuities', href: 'https://www.thrivent.com/annuities' },
    {
      text: 'Mutual Funds',
      href: 'https://www.thrivent.com/investments/mutual-funds',
    },
  ],
};

export const insuranceLinks: ColumnLinks = {
  title: 'Insurance',
  links: [
    {
      text: 'Disability Insurance',
      href: 'https://www.thrivent.com/insurance/disability-insurance',
    },
    {
      text: 'Life Insurance',
      href: 'https://www.thrivent.com/insurance/life-insurance',
    },
    {
      text: 'Long Term Care Strategy',
      href: 'https://www.thrivent.com/insurance/long-term-care-insurance',
    },
  ],
};

export const primaryLink: Link = {
  text: 'All Products & services',
  href: 'https://thrivent.com/product-overview',
};

export const promoCard: PromoCard = {
  title: 'Find a financial advisor',
  description: 'Get started on your journey to financial confidence today.',
  callToActionText: 'Start your search',
  callToActionHref: 'https://www.thrivent.com/find-a-financial-advisor',
};
